const links = document.querySelectorAll('.faq-navigation__button');

// Highlight on scroll
window.addEventListener('scroll', (event) => {
  const fromTop = window.scrollY;

  links.forEach(link => {
    const section = document.querySelector(`.faq__component[data-section="${link.dataset.section}"]`);
    const offsetTop = section.offsetTop - 60;

    if (section) {
      if (offsetTop <= fromTop && offsetTop + section.clientHeight > fromTop) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    }
  });
});

// Scroll to link
links.forEach(link => {
  link.addEventListener('click', event => {
    event.preventDefault();
    const section = document.querySelector(`.faq__component[data-section="${event.currentTarget.dataset.section}"]`)

    window.scrollTo({
      top: section.offsetTop - 40,
      behavior: "smooth"
    });
  });
});

// Dropdowns
const faqs = document.querySelectorAll('.faq__item-question');
faqs.forEach(faq => {
  faq.addEventListener('click', event => {
    const parent = event.currentTarget.parentElement;
    const content = parent.querySelector('.faq__item-answer');

    parent.classList.toggle('active');
    slideToggle(content, 300);
  });
});